import { formatCalendarDate } from 'utils/date';

// CARD MACHINES (owner 2 Nov 2026): shared wording for the event profile's
// Card machines and the Devices page's Last used / history.

/** "10/09/2026 – 10/11/2026", or one date when it is a single day. */
export const formatMachineDays = (firstDay: string, lastDay: string) =>
  firstDay === lastDay
    ? formatCalendarDate(firstDay)
    : `${formatCalendarDate(firstDay)} – ${formatCalendarDate(lastDay)}`;

/** The machine's name; a deleted machine says so, a nameless one too. */
export const formatMachineName = ({
  name,
  removed,
}: {
  removed?: boolean;
  name: string | null;
}) => {
  const label = name?.trim() || 'Unknown machine';
  return removed ? `${label} (deleted)` : label;
};
